import { render, staticRenderFns } from "./ExternalDataInModal.vue?vue&type=template&id=821eb288"
import script from "./ExternalDataInModal.vue?vue&type=script&lang=js"
export * from "./ExternalDataInModal.vue?vue&type=script&lang=js"
import style0 from "./ExternalDataInModal.vue?vue&type=style&index=0&id=821eb288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports